import { apiClient } from './apiClient';
import { LoginRequest, LoginResponse, RefreshTokenRequest, RefreshTokenResponse, LogoutRequest } from './models/ApiAuth';

export const authApi = {
  /**
   * Đăng nhập với tài khoản basic
   */
  login: async (loginData: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/api/v1/accounts/login/with_basic', loginData);
    return response.data;
  },

  /**
   * Refresh access token
   */
  refreshToken: async (refreshData: RefreshTokenRequest): Promise<RefreshTokenResponse> => {
    const response = await apiClient.post<RefreshTokenResponse>('/api/v1/accounts/refresh', refreshData);
    return response.data;
  },

  /**
   * Logout
   */
  logout: async (logoutData: LogoutRequest): Promise<void> => {
    await apiClient.post('/api/v1/accounts/logout', logoutData);
  }
}; 